import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClientsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.001,
			cy: 8.63,
			r: 1.501,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 13.506,
			height: 13.506,
			x: 2.247,
			y: 2.248,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			rx: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.749,
			cy: 8.255,
			r: 1.876,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M10.876 15.753v-.75a2.626 2.626 0 0 0-2.626-2.626H5.29a2.62 2.62 0 0 0-2.548 2.02m9.259-2.016h1.13a2.6 2.6 0 0 1 2.377 1.557"
		})
	]
});
export default SvgClientsinline;
